import type { BaseOptionType } from "antd/lib/select"

import type { UpdateLeadParams } from "../../Lead/redux/lead.types.ts"
import type { LeadSalesManager } from "../../Lead/types/lead.types.ts"
import type { LeadListItem } from "../types/types.ts"

/** Shows a saved inline edit on its row before the reload lands, touching
 *  only the fields the row editor sends; everything else stays as listed. */
export const applyRowEdit = (
  row: LeadListItem,
  edit: UpdateLeadParams,
  sourceOptions: BaseOptionType[] | undefined
) => {
  if (edit.lead_name !== undefined) row.lead_name = edit.lead_name ?? ""
  if (edit.sales_price !== undefined) row.sales_price = edit.sales_price ?? null

  // The list shows a source by its label; the editor sends its value.
  if (edit.source === null) row.source = null
  else if (edit.source !== undefined) {
    const label = sourceOptions?.find((o) => o?.value === edit.source)?.label
    if (typeof label === "string") row.source = label
  }

  // The editor sends ids only, so a person not already on the row has no
  // name to show yet; the reload fills that case in.
  if (edit.sales_manager !== undefined) {
    const listed = row.sales_manager ?? []
    const next = (edit.sales_manager ?? []).map((sent) => {
      const known = listed.find((s) => s.id === sent.id)
      return known ? { ...known, is_main: sent.is_main } : null
    })
    if (next.every((s): s is LeadSalesManager => s !== null))
      row.sales_manager = next
  }
}
